<template>
    <div class="fixed h-screen w-screen bg-black opacity-20 top-0 left-0 z-[60]" v-if="isActive" @click="close"></div>
    <div
        ref="panel"
        class="side-panel fixed bg-white h-screen top-0 right-0 w-[500px] z-[61] transition-transform duration-300 border-t border-grayxlight"
        @transitionend="onTransitionEnd"
        :class="{
            'transform translate-x-full': !isActive,
            'side-panel--glass': isActive
        }"
    >
        <button @click="close" class="absolute top-[9px] right-[10px] text-gray">
            <icon>
                <IconClose />
            </icon>
        </button>
        <slot v-if="isActive"></slot>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import IconClose from '../../ui/icons/IconClose.vue'
const isActive = ref(false)
const panel = ref<HTMLElement | null>(null)
const emit = defineEmits(['close', 'opened'])
const toggle = () => isActive.value = !isActive.value
const close = () => {
    isActive.value = false
    emit('close')
}
const onTransitionEnd = (event: TransitionEvent) => {
    if (event.propertyName === 'transform' && isActive.value) emit('opened')
}

defineExpose({
    toggle,
    close,
    panel
});
</script>

<style scoped>
.side-panel--glass {
    border-color: rgb(255 255 255 / 0.58);
    background: rgb(255 255 255 / 0.9);
    box-shadow: -8px 0 20px oklch(0% 0 0 / 0.1);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
}
</style>
